// extracted by mini-css-extract-plugin
module.exports = {"base":"organism1-m__base__caj-b"};